<template>
  <div>
    <div class="vz-order-view-blocks-title text-h1 mb-20">
      Груз
    </div>

    <div class="vz-order-view-blocks">
      <vz-cargo-dimension-view :order="localOrder" />
      <vz-cargo-categories-view :order="localOrder" />
    </div>
  </div>
</template>

<script setup lang="ts">
import VzCargoDimensionView from '~/components/personal/order/vz-order-view/cargo/vz-cargo-dimension-view.vue'
import VzCargoCategoriesView from '~/components/personal/order/vz-order-view/cargo/vz-cargo-categories-view.vue'
import {PropType} from 'vue';
import {OrderForm} from '~/types/types';
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';

const props = defineProps({
  order: {
    type: Object as PropType<OrderForm>,
    default: () => ({})
  }
})

const { orderView } = storeToRefs(useOrderStore())

const localOrder = computed(() => {
  return props.order?.cargo ? props.order : orderView.value
})
</script>